<template>
  <section
    v-if="sidebarComponents.length === 0"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'};`"
  >
    <div
      class="tw-grid tw-h-full tw-w-full tw-max-w-[550px] tw-grid-cols-1 tw-gap-y-4 lg:tw-max-w-none lg:tw-grid-cols-12 lg:tw-gap-x-12 xl:tw-gap-20"
    >
      <div
        class="tw-col-span-1 tw-flex tw-items-center tw-justify-center lg:tw-col-span-5"
        :class="{ 'lg:tw-order-last': vars.isReversedBool }"
      >
        <div style="position: relative; aspect-ratio: 2/3">
          <!-- Video iframe doğrudan gösterimi -->
          <iframe
            v-if="vars.videoUrl"
            class="tw-w-full tw-rounded-[var(--rounded)] tw-object-cover lg:!tw-max-w-none"
            :src="vars.videoUrl"
            :style="
              vars.isVerticalBool
                ? ' aspect-ratio:2/3; max-width: 550px; border-radius: var(--rounded)'
                : ' aspect-ratio: 16/9; max-width: 550px; border-radius: var(--rounded)'
            "
            frameborder="0"
            allowfullscreen
          ></iframe>

          <!-- Sadece fotoğraf gösterimi - NuxtImg kullanarak -->
          <NuxtImg
            v-if="vars.photoImage && !vars.videoUrl"
            :src="vars.photoImage"
            :alt="vars.titleText"
            style="aspect-ratio: 2/3; border-radius: var(--rounded)"
            class="tw-h-full tw-w-full tw-object-cover"
          />
        </div>
      </div>

      <div
        class="tw-col-span-1 tw-mt-6 tw-flex tw-w-full tw-max-w-[550px] tw-flex-col tw-justify-center tw-gap-2 lg:tw-col-span-7 lg:tw-mt-0 lg:tw-max-w-none xl:tw-gap-5"
      >
        <h2 class="n-title-primary">{{ vars.titleText }}</h2>
        <p v-if="vars.roleText">{{ vars.roleText }}</p>
        <div class="tw-flex tw-flex-col tw-gap-4 tw-py-4">
          <nuxt-link
            :external="true"
            v-if="vars.mailText"
            :to="`mailto:${vars.mailText}`"
            class="n-link tw-flex tw-max-w-fit tw-items-center tw-gap-1"
            style="color: var(--c-primary);"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.66671 13.3334C2.30004 13.3334 1.98604 13.2027 1.72471 12.9414C1.46338 12.68 1.33293 12.3662 1.33338 12V4.00002C1.33338 3.63335 1.46404 3.31935 1.72538 3.05802C1.98671 2.79669 2.30049 2.66624 2.66671 2.66669H13.3334C13.7 2.66669 14.014 2.79735 14.2754 3.05869C14.5367 3.32002 14.6672 3.6338 14.6667 4.00002V12C14.6667 12.3667 14.536 12.6807 14.2747 12.942C14.0134 13.2034 13.6996 13.3338 13.3334 13.3334H2.66671ZM8.00004 8.66669L13.3334 5.33335V4.00002L8.00004 7.33335L2.66671 4.00002V5.33335L8.00004 8.66669Z"
                fill="var(--c-primary)"
              />
            </svg>
            {{ vars.mailText }}
          </nuxt-link>

          <nuxt-link
            :external="true"
            v-if="vars.phoneText"
            :to="`tel:${vars.phoneText}`"
            class="n-link tw-flex tw-max-w-fit tw-items-center tw-gap-1"
            style="color: var(--c-primary);"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.34 10.2533C12.52 10.2533 11.7267 10.12 10.9867 9.88C10.8707 9.8407 10.7461 9.83487 10.627 9.86317C10.5079 9.89147 10.3992 9.95275 10.3133 10.04L9.26667 11.3533C7.38 10.4533 5.61333 8.75333 4.67333 6.8L5.97333 5.69333C6.15333 5.50667 6.20667 5.24667 6.13333 5.01333C5.88667 4.27333 5.76 3.48 5.76 2.66C5.76 2.3 5.46 2 5.1 2H2.79333C2.43333 2 2 2.16 2 2.66C2 8.85333 7.15333 14 13.34 14C13.8133 14 14 13.58 14 13.2133V10.9133C14 10.5533 13.7 10.2533 13.34 10.2533Z"
                fill="var(--c-primary)"
              />
            </svg>
            {{ vars.phoneText }}
          </nuxt-link>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-2">
          <p v-for="(item, index) in descriptions" :key="`infobox-descriptions-${index}`">
            {{ item.description }}
          </p>
        </div>
        <nuxt-link
          v-if="vars.buttonLinkUrl"
          class="tw-mt-6 tw-max-w-fit xl:tw-mt-8"
          :class="`n-${vars.buttonTypeText}`"
          :external="true"
          :to="vars.buttonLinkUrl"
        >
          {{ vars.buttonLabelText }}
        </nuxt-link>
      </div>
    </div>
  </section>
  <div
    v-if="sidebarComponents.length > 0"
    :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'};`"
    class="tw-p-6"
  >
    <div class="tw-grid tw-h-full tw-w-full tw-max-w-[550px] tw-grid-cols-1 tw-gap-y-4">
      <div class="tw-col-span-1 tw-flex tw-flex-col tw-items-center tw-justify-center">
        <h3 class="n-title-primary tw-mb-4 tw-self-start">{{ vars.titleText }}</h3>
        <div style="position: relative; aspect-ratio: 2/3">
          <!-- Video iframe doğrudan gösterimi -->
          <iframe
            v-if="vars.videoUrl"
            class="tw-w-full tw-rounded-[var(--rounded)] tw-object-cover"
            :src="vars.videoUrl"
            :style="
              vars.isVerticalBool
                ? ' aspect-ratio:2/3; max-width: 550px; border-radius: var(--rounded)'
                : ' aspect-ratio: 16/9; max-width: 550px; border-radius: var(--rounded)'
            "
            frameborder="0"
            allowfullscreen
          ></iframe>

          <!-- Sadece fotoğraf gösterimi - NuxtImg kullanarak -->
          <NuxtImg
            v-if="vars.photoImage && !vars.videoUrl"
            :src="vars.photoImage"
            :alt="vars.titleText"
            style="aspect-ratio: 2/3; border-radius: var(--rounded)"
            class="tw-h-full tw-w-full tw-object-cover"
          />
        </div>
      </div>

      <div class="tw-col-span-1 tw-mt-6 tw-flex tw-w-full tw-max-w-[550px] tw-flex-col tw-justify-center tw-gap-2">
        <p v-if="vars.roleText">{{ vars.roleText }}</p>
        <div class="tw-flex tw-flex-col tw-gap-4 tw-py-4">
          <nuxt-link
            :external="true"
            v-if="vars.mailText"
            :to="`mailto:${vars.mailText}`"
            class="n-link tw-flex tw-max-w-fit tw-items-center tw-gap-1"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.66671 13.3334C2.30004 13.3334 1.98604 13.2027 1.72471 12.9414C1.46338 12.68 1.33293 12.3662 1.33338 12V4.00002C1.33338 3.63335 1.46404 3.31935 1.72538 3.05802C1.98671 2.79669 2.30049 2.66624 2.66671 2.66669H13.3334C13.7 2.66669 14.014 2.79735 14.2754 3.05869C14.5367 3.32002 14.6672 3.6338 14.6667 4.00002V12C14.6667 12.3667 14.536 12.6807 14.2747 12.942C14.0134 13.2034 13.6996 13.3338 13.3334 13.3334H2.66671ZM8.00004 8.66669L13.3334 5.33335V4.00002L8.00004 7.33335L2.66671 4.00002V5.33335L8.00004 8.66669Z"
                fill="var(--c-secondary)"
              />
            </svg>
            {{ vars.mailText }}
          </nuxt-link>

          <nuxt-link
            :external="true"
            v-if="vars.phoneText"
            :to="`tel:${vars.phoneText}`"
            class="n-link tw-flex tw-max-w-fit tw-items-center tw-gap-1"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.34 10.2533C12.52 10.2533 11.7267 10.12 10.9867 9.88C10.8707 9.8407 10.7461 9.83487 10.627 9.86317C10.5079 9.89147 10.3992 9.95275 10.3133 10.04L9.26667 11.3533C7.38 10.4533 5.61333 8.75333 4.67333 6.8L5.97333 5.69333C6.15333 5.50667 6.20667 5.24667 6.13333 5.01333C5.88667 4.27333 5.76 3.48 5.76 2.66C5.76 2.3 5.46 2 5.1 2H2.79333C2.43333 2 2 2.16 2 2.66C2 8.85333 7.15333 14 13.34 14C13.8133 14 14 13.58 14 13.2133V10.9133C14 10.5533 13.7 10.2533 13.34 10.2533Z"
                fill="var(--c-secondary)"
              />
            </svg>
            {{ vars.phoneText }}
          </nuxt-link>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-2">
          <p v-for="(item, index) in descriptions" :key="`infobox-descriptions-${index}`">
            {{ item.description }}
          </p>
          
        </div>
        <nuxt-link
          v-if="vars.buttonLinkUrl"
          class="tw-mt-6 tw-max-w-fit xl:tw-mt-8"
          :class="`n-${vars.buttonTypeText}`"
          :external="true"
          :to="vars.buttonLinkUrl"
        >
          {{ vars.buttonLabelText }}
        </nuxt-link>
       
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  mixins: [ComponentMixin],

  data() {
    return {
      isVisible: false,
    };
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },

    ...mapState(useWebsiteStore, ['sidebarComponents']),
  },
});
</script>
